import {getheaders} from '../../service/authService';

export async function responseError(response) {
    const raw = await response.text();
    try {
        const data = JSON.parse(raw);
        return data.detail || data.reason || data.message || `Request failed (${response.status}).`;
    } catch (_) {
        return `Request failed (${response.status}). Please try again.`;
    }
}

export async function collaborationApi(path, method = 'GET', body, signal) {
    const response = await fetch(`/api/collaboration${path}`, {
        method, headers: getheaders(), body: body === undefined ? undefined : JSON.stringify(body), signal,
    });
    if (!response.ok) {
        const error = new Error(await responseError(response));
        error.status = response.status;
        throw error;
    }
    return response.json();
}
